import { render } from "./HeroSub.vue?vue&type=template&id=6e63021b&scoped=true&ts=true"
import script from "./HeroSub.vue?vue&type=script&lang=ts"
export * from "./HeroSub.vue?vue&type=script&lang=ts"

import "./HeroSub.vue?vue&type=style&index=0&id=6e63021b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e63021b"]])

export default __exports__